import React, { Component, useState, useEffect } from "react";
import { Collapsible, CollapsibleItem, Icon, Button } from "react-materialize";
import config from "../../config";
import API from "../../utils/API";
import Html from "../../utils/Html";
import Func from "../../utils/Func";
import FormFunc from "../../utils/FormFunc";
import Feature from "../../utils/Feature";
import $ from "jquery";
import GroupItems from "./usergroups/GroupItems";
import { useInfo } from "context/InfoContext";

export default function UserGroups({ userData, handleEvents }) {
  const boxName = "content-usergroups";
  const { filters, filterData } = useInfo();
  useEffect(() => {}, []);
  return (
    <div id="usergroups-box" className="">
      <Collapsible accordion={false}>
        {filterData.data.collectionGroups.map((item, i) => {
          return (
            <CollapsibleItem
              key={"collection-" + i}
              className="collap-item"
              expanded={true}
              header={<h6>{"User Group : " + item.name.toUpperCase()}</h6>}
              //icon={<Icon>filter_drama</Icon>}
              node="div"
            >
              <GroupItems
                data={{
                  inx: i,
                  groups: filterData.data.groups[item.collection_id],
                  userGroups: filters?.user_group ?? [],
                }}
                handleEvents={handleEvents}
              />
            </CollapsibleItem>
          );
        })}
      </Collapsible>
      <div
        key={boxName + "-btn-save"}
        className={boxName + " row"}
        style={{ textAlign: "center", marginTop: "25px" }}
      >
        <Button
          className=""
          id="btn-save"
          node="button"
          waves="light"
          style={{width: "150px"}}
          onClick={handleEvents.OnSave}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
